import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import ProductImages from "./ProductImages";
import Text from "component/typography/Text";
import Picker from "component/picker/Picker";
import Button from "component/button/Button";
import AddAndChangeCartItem from "component/section/AddAndChangeCartItem";

import { sizes, colors, strings } from "asset/constant";
import { css } from "style";
import {
  sn,
  isEqualArrays,
  changeArrayAt,
  priceFormatter,
  removeArrayItemAt,
} from "utils";
import { useFavorite } from "client/api";
import tinycolor from "tinycolor2";

export default function ProductCard(props: { product: ProductT }) {
  const { product } = props;
  const [isFav, setIsFav] = useState(product.is_favorte);

  const [selectedVars, setSelectedVars] = useState<
    Array<PickerItemT & { parentTitle?: string }>
  >([]);

  const favoriteMut = useFavorite(product.id);
  const _onFav = () => {
    setIsFav((prev) => (prev === 1 ? 0 : 1));
    favoriteMut.mutate();
  };

  return (
    <View style={styles.container}>
      <View style={[css.overFlowH, css.fixFitContent]}>
        {[5, -2, 1, -4].map((num: number) => {
          return (
            <View
              key={String(num)}
              style={[
                css.fix,
                css.width(300),
                css.height(300),
                css.radius(200),
                css.border(2, colors.theme + "05"),
                { right: num * -25, bottom: -num * 30 },
              ]}
            />
          );
        })}
      </View>

      <View>
        <View style={[{ height: 70, flexDirection: "row" }]}>
          <View style={{ width: 50 }}>
            <Button
              circle={35}
              bgColor={colors.transparent}
              style={{ marginBottom: 5 }}
              icon={{
                size: 20,
                color: colors.theme,
                name: product.recommended === 1 ? "star" : "staro",
              }}
            />

            <Button
              onPress={_onFav}
              bgColor={colors.transparent}
              circle={35}
              icon={{
                name: isFav === 1 ? "heart" : "hearto",
                size: 18,
                color: colors.danger,
              }}
            />
          </View>

          <View
            style={{
              ...css.container,
              justifyContent: "center",
              paddingRight: sn(60, 60, 75, 75),
            }}
          >
            <Text
              size={"xl"}
              weight="bold"
              numberOfLines={2}
              color={colors.text.dark}
              style={{ lineHeight: 23 }}
            >
              {product.title}
            </Text>
          </View>

          <ProductImages images={product?.images} />

          {product?.discount === 1 && (
            <View
              style={{
                top: -10,
                height: 20,
                paddingHorizontal: 10,
                position: "absolute",
                right: sn(60, 60, 70, 75),
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 10,
                backgroundColor: tinycolor(colors.success)
                  .lighten(45)
                  .toString(),
                ...css.shadowForWeb(5),
              }}
            >
              <Text
                size={"xs"}
                weight="bold"
                color={tinycolor(colors.success).darken(15).toString()}
              >
                تخفیف دار
              </Text>
            </View>
          )}
        </View>

        {product?.variations && product?.variations?.length > 0 && (
          <View style={{ ...css.rRowCenterAlign, padding: sizes.space }}>
            {product?.variations?.map((variation: VariationT, key: number) => {
              return (
                <React.Fragment key={String(key)}>
                  {product?.variations?.length > 1 && key !== 0 && (
                    <View style={{ width: 5 }} />
                  )}

                  <View style={css.container}>
                    <View style={{ marginBottom: sn(5, 5, 8, 10) }}>
                      <Text weight="bold">
                        {"   "}
                        {variation.title}
                      </Text>
                    </View>

                    <Picker
                      onSelect={(item) => {
                        const _selectedVars = [...selectedVars];
                        const _indexOfItem = _selectedVars.findIndex(
                          (e) => e.parentTitle === variation.title
                        );

                        if (item) {
                          const newItemVal = {
                            ...item,
                            parentTitle: variation.title,
                          };

                          _indexOfItem > -1
                            ? setSelectedVars(
                                changeArrayAt(
                                  _selectedVars,
                                  _indexOfItem,
                                  newItemVal
                                )
                              )
                            : setSelectedVars([..._selectedVars, newItemVal]);
                        } else {
                          _indexOfItem > -1
                            ? setSelectedVars(
                                removeArrayItemAt(_selectedVars, _indexOfItem)
                              )
                            : null;
                        }
                      }}
                      data={variation.items}
                      hideError
                    />
                  </View>
                </React.Fragment>
              );
            })}
          </View>
        )}

        <View
          style={{
            ...css.rRowCenterAlign,
            ...css.justifySBetween,
            padding: sizes.space,
          }}
        >
          {product?.variations?.length === selectedVars?.length &&
            (selectedVars.findIndex((e) => e.is_customized === 1) > -1 ? (
              <></>
            ) : (
              <View style={{ ...css.rRowCenterAlign, width: 130 }}>
                <Text color={colors.text.dark} weight="extraBold" size={18}>
                  {selectedVars?.reduce(
                    (sum, v) => sum + Number(v.price_ratio),
                    0
                  )
                    ? priceFormatter(
                        selectedVars?.reduce(
                          (sum, v) => sum + Number(v.price_ratio),
                          0
                        ) * product.price
                      )
                    : priceFormatter(product.price)}
                </Text>
                <Text weight="extraBold" size={"xs"}>
                  {" "}
                  {strings.currency}{" "}
                </Text>
              </View>
            ))}

          <AddAndChangeCartItem
            disabled={product?.variations?.length !== selectedVars?.length}
            productId={product.id}
            variations={selectedVars}
            companyId={product.company_id}
            step={
              product.binary_variations?.find((e) =>
                isEqualArrays(
                  e,
                  selectedVars.map((s) => s.id)
                )
              )
                ? 2
                : 1
            }
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "94%",
    alignSelf: "center",
    marginBottom: 15,
    marginTop: sn(15, 15, 35, 35),
    ...css.shadowForWeb(10),
    backgroundColor: colors.white,
    borderRadius: sizes.radius.lg,
  },
});
